<template>
  <div class="cx_payjp"><Button :caption="caption" :disabled="true" v-if="hasPerm == false"/> </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import * as Common from "@/agiles/common";

@Component
export default class PayJPCheckout extends Vue {
 @Prop({default:''}) public caption:string;
 @Prop({default:null}) public perm:string; 
  public scriptTag: Element;
  public mounted() {
    if (this.hasPerm){
        (window as any).onCardCreatedPayJP = this.onCardCreatedPayJP;
        let payJPscript = document.createElement("script");
        payJPscript.setAttribute("src", "https://checkout.pay.jp/");
        payJPscript.setAttribute("class", "payjp-button");
        // payJPscript.setAttribute("data-key", "pk_test_ecc1d4676c78ef3dad60a42a");
        payJPscript.setAttribute("data-key", process.env.VUE_APP_PAYJP);
        payJPscript.setAttribute("data-on-created", "onCardCreatedPayJP");
        payJPscript.setAttribute("data-text", this.caption);
        payJPscript.setAttribute("data-submit-text", "カード情報を登録する");
        payJPscript.setAttribute("data-partial", "true");
        payJPscript.setAttribute("data-payjp-three-d-secure", "true");
        payJPscript.setAttribute("data-payjp-three-d-secure-workflow", "subwindow");
        this.scriptTag = payJPscript;
        this.$el.appendChild(payJPscript);
    }
  }

  public get hasPerm(){
      return this.perm ? this.$api.perms.hasMenuPermission(this.perm) : true;
  }
  public onCardCreatedPayJP(arg: any) {
      this.$emit('click',arg);
      this.$nextTick(()=>{
          (document.getElementById("payjp_checkout_box").firstChild as HTMLInputElement).value = this.caption;
          });
  }

  public beforeDestroy() {
    this.$el.removeChild(this.scriptTag);
    document.getElementById("payjp-checkout-iframe").parentElement.remove();
    (window as any).PayjpCheckout = null;
    (window as any).onCardCreatedPayJP = null;
  }
}
</script>
<style lang="scss">
.cx_payjp {
    #payjp_checkout_box {
        input[type=button],input[type=button].has-token {
            font-size: 16px;
  
            color: #444;
            border: 1px solid #ccc;
            border-radius: 5px;
            // padding: 4px 20px;
            font-weight: 400;
            background: linear-gradient(to bottom, #f9f9f9 0, #e0e0e0 100%);
            text-shadow: 0 1px 0 rgba(255, 255, 255, 1), 0 0 0 rgba(255, 255, 255, 0);
            box-shadow: none;
            white-space: nowrap;
            &:hover:not(:disabled){
                color: #444;
                border: 1px solid #bbb;
                background: linear-gradient(to bottom, #f6f6f6 0, #d4d4d4 100%);
            }
            &:active:not(:disabled){
                color: #444 !important;
                border: 1px solid #999 !important;
                background: linear-gradient(to bottom, #ececec 0, #c9c9c9 100%);
                box-shadow: none !important;
            }  
            &:focus{
                box-shadow: none !important;
            }
            &:disabled{
                border: 1px solid #aaa;
                color: #444;
                background-color: #f6f6f6
            }
        }
    }
}
</style>